import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetIndividualTaxInformationRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetIndividualTaxInformationResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setIndividualTaxInformation = (
  request: SetIndividualTaxInformationRequest,
  options?: CashRequestOptions
) =>
  post<SetIndividualTaxInformationRequest, SetIndividualTaxInformationResponse>(
    '/2.0/cash/set-individual-tax-information',
    request,
    { ...options, rejectOnError: true }
  )
